<ion-datetime
	[ngModel]="_date"
	(ionChange)="ionChange($event)"
	[presentation]="presentation"
	[preferWheel]="true"
	class="picker"
	size="cover"
></ion-datetime>
